import { render, staticRenderFns } from "./EventVideo.vue?vue&type=template&id=cab7b156&scoped=true"
import script from "./EventVideo.vue?vue&type=script&lang=ts"
export * from "./EventVideo.vue?vue&type=script&lang=ts"
import style0 from "./EventVideo.vue?vue&type=style&index=0&id=cab7b156&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab7b156",
  null
  
)

export default component.exports